import TableBody from '@mui/material/TableBody';
import React, { memo, useCallback } from 'react';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import SwitchComponent from './Inputs/SwitchComponent';
import { TableCell, TableRow } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/* import TableCell from './TableCell';
import TableRow from './TableRow'; */

const TableBodyPermisos = memo(({ rows, inputHandler, formik }) => {
  const theme = useTheme();

  const permisos_modulos_ver = rows.map((item) => item.name_switch_ver);

  const permisos_modulos_editar = rows
    .filter((item) => item.name_switch_editar)
    .map((item) => item.name_switch_editar.toString().trim());

  const customIncludes = (arr, string) => {
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i];
      if (string === item) {
        return true;
      }
    }
    return false;
  };
  const switchHandler = useCallback(
    (e) => {
      const value = e.target.checked ? 1 : 0;
      /*    
    El includes no funciona en el modulo de Tickets para encender cuando toquen el de editar 
      console.log(e.target.name.includes(permisos_modulos_editar));
      console.log(customIncludes(permisos_modulos_editar, e.target.name)); 
    */
      if (e.target.name === permisos_modulos_ver[0]) {
        //setear a todos en falso cuando setean a falso al padre
        if (!e.target.checked) {
          const subPermisos = permisos_modulos_ver.slice(
            1,
            permisos_modulos_ver.length,
          );
          subPermisos.forEach((item) => {
            formik.setFieldValue(item, 0);
          });
          if (permisos_modulos_editar.length > 0) {
            permisos_modulos_editar.forEach((item) => {
              formik.setFieldValue(item, 0);
            });
          }

          formik.setFieldValue(e.target.name, value);
        } else {
          formik.setFieldValue(e.target.name, value);
        }
      } else if (
        customIncludes(permisos_modulos_editar, e.target.name) &&
        e.target.checked
      ) {
        //Caso que ponen el editar en true
        formik.setFieldValue(e.target.name, value);
        //extraigo el nombre del campo y lo transformo en el campo de permiso de "ver"
        const aux_ver = e.target.name.slice(0, -2) + '_v';

        if (aux_ver === permisos_modulos_ver[0]) {
          formik.setFieldValue(permisos_modulos_ver[0], value);
        } else {
          formik.setFieldValue(permisos_modulos_ver[0], value);
          formik.setFieldValue(aux_ver, value);
        }
      } else if (
        customIncludes(permisos_modulos_ver, e.target.name) &&
        !e.target.checked
      ) {
        //Caso que ponen el ver en false debo poner el editar en false
        formik.setFieldValue(e.target.name, value);
        //extraigo el nombre del campo y lo transformo en el campo de permiso de "editar"
        const aux_editar = e.target.name.slice(0, -2) + '_e';
        if (customIncludes(permisos_modulos_editar, aux_editar)) {
          formik.setFieldValue(aux_editar, value);
        }
      } else {
        //prender al padre si encienden al hijo

        if (e.target.checked && !formik.values[permisos_modulos_ver[0]]) {
          formik.setFieldValue(e.target.name, value);
          formik.setFieldValue(permisos_modulos_ver[0], 1);
        } else {
          formik.setFieldValue(e.target.name, value);
          formik.setFieldValue(permisos_modulos_ver[0], 1);
        }
      }
    },
    [permisos_modulos_ver, formik, permisos_modulos_editar],
  );

  return (
    <TableBody sx={{ '&:first-of-type': { borderRadius: 3 } }}>
      {rows.map((row, index) => (
        <TableRow
          key={row.name}
          sx={{
            borderBottom:
              theme.palette.mode === 'dark'
                ? ' 1px solid rgb(81, 81, 81) '
                : ' 1px solid rgb(224, 224, 224) ',
            '&:last-child td, &:last-child th': {
              border: '0px',
            },
            '&:first-of-type td, &:first-of-type th': {
              backgroundColor:
                theme.palette.mode === 'dark' && row.name.includes('Módulo')
                  ? 'rgba(0, 0, 0, 0.465)'
                  : theme.palette.mode === 'light' &&
                    row.name.includes('Módulo')
                  ? 'rgba(0, 0, 0, 0.165)'
                  : 'transparent',
              fontWeight: 'bold',
              fontSize: '1rem',
            },
          }}
          /*    sx={
            {
               backgroundColor: '#455a6473', 
             '&:last-child td, &:last-child th': { border: 0 },
               '&:first-of-type td, &:first-of-type th': {
          
              backgroundColor: 'rgba(0, 0, 0, 0.105)',
              fontWeight: 'bold',
              fontSize: '1rem',
            },

            '&:first-of-type tr': { borderRadius: 3 },
            }
          } */
        >
          <TableCell component="th" scope="row">
            {row.name}
          </TableCell>
          <TableCell align="center">
            {index === 0 ? (
              <FormControlLabel
                control={
                  <SwitchComponent
                    formik={formik}
                    switchHandler={switchHandler}
                    property={row.name_switch_ver}
                  />
                }
              />
            ) : (
              <FormControlLabel
                control={
                  <SwitchComponent
                    switchHandler={switchHandler}
                    formik={formik}
                    property={row.name_switch_ver}
                  />
                }
              />
            )}
          </TableCell>
          <TableCell align="center">
            {row.name_switch_editar ? (
              <Switch
                onChange={switchHandler}
                name={row.name_switch_editar}
                checked={!!formik.values[row.name_switch_editar]}
              />
            ) : (
              <></>
            )}
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
});
/* export default React.memo(
  TableBodyPermisos,
  (prevProps, nextProps) =>
    prevProps.formik.values[prevProps.property] ===
    nextProps.formik.values[nextProps.property],
); */
export default TableBodyPermisos;
